function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.42666,11.74219,17.65029,6.28467a2.06261,2.06261,0,0,0-1.86621-1.12744l-7.585.00634A1.881,1.881,0,0,0,6.2538,6.28467l-.001.00244L3.57021,11.748l-.00256.01074a.47055.47055,0,0,0-.04724.20068V16.75A2.08593,2.08593,0,0,0,5.6288,18.85742H18.371A2.08594,2.08594,0,0,0,20.47939,16.75V11.95947A.48035.48035,0,0,0,20.42666,11.74219ZM7.1122,6.71094A.97385.97385,0,0,1,8.12,6.11523h7.66406a1.09634,1.09634,0,0,1,1.01074.60059l2.42358,4.76465H15.11416a.47852.47852,0,0,0-.40332.2207l-1.39161,2.17432H10.58486l-1.3916-2.17432a.47853.47853,0,0,0-.40332-.2207H4.76937ZM18.371,17.89941H5.6288A1.13818,1.13818,0,0,1,4.47939,16.75V12.43848H8.52822l1.3916,2.17431a.47851.47851,0,0,0,.40332.22071H13.581a.47851.47851,0,0,0,.40332-.22071l1.3916-2.17431h4.14454V16.75A1.1382,1.1382,0,0,1,18.371,17.89941Z"
});

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.ace20631.svg";
export { ForwardRef as ReactComponent };